export function resizeImageToWidth(
  file: File,
  onSuccess: (resizedFile: File) => void,
  onError: (originalFile: File) => void,
  targetWidth = 300
) {
  const reader = new FileReader();

  reader.onload = (event) => {
    const img = new Image();

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        onError(file);
        return;
      }

      const aspectRatio = img.height / img.width;
      const targetHeight = targetWidth * aspectRatio;

      canvas.width = targetWidth;
      canvas.height = targetHeight;

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      canvas.toBlob(
        (blob) => {
          if (blob) {
            const resizedFile = new File([blob], file.name, {
              type: file.type,
              lastModified: Date.now(),
            });
            onSuccess(resizedFile);
          } else {
            onError(file);
          }
        },
        file.type,
        0.9
      );
    };

    img.onerror = () => onError(file);
    img.src = event.target?.result as string;
  };

  reader.onerror = () => onError(file);
  reader.readAsDataURL(file);
}
